import moment from 'moment';
import {FFM_OPTION} from '../../../Constants';
import {
  PREFIX_RH,
  PREFIX_T,
  PREFIX_WIND_MAG_KPH
} from '../shared/behaviour_models_utils';
import {calculateDIR} from '../shared/direction';
import {minZero} from '../../point_utils';

export {calculateDIR};

function timeFromWeatherRow(wd) {
  if (typeof wd.sortIndex === 'number') {
    return moment(wd.sortIndex);
  }
  return moment(wd.name, 'ddd DD/MM hh:mm A');
}

export function calculateSFFM(wd, vars) {
  const t = timeFromWeatherRow(wd);
  const hr = t.hours();

  const relative_humidity = wd[PREFIX_RH];
  const air_temp = wd[PREFIX_T];
  if (typeof relative_humidity !== 'undefined' &&
      typeof air_temp !== 'undefined') {
    if (vars.ffm_option === FFM_OPTION.MALLEE) {
      if (hr >= 12 && hr <= 17) {
        return minZero(4.79 + 0.173 * relative_humidity - 0.1 * (air_temp - 25) - 0.27);
      }
      return minZero(4.79 + 0.173 * relative_humidity - 0.1 * (air_temp - 25));
    }
    if (hr > 5 && hr < 21) {
      return minZero(4.37 + 0.161 * relative_humidity - 0.1 * (air_temp - 25) - 0.27);
    }
    return minZero(4.37 + 0.161 * relative_humidity - 0.1 * (air_temp - 25));
  }
  return undefined;
}

export function calculatePGO10(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const sffm = calculateSFFM(wd, vars);
  if (typeof sffm !== 'undefined' &&
      typeof wind_speed !== 'undefined') {
    return 1 / (1 + Math.exp(-(14.626 + 0.2066 * wind_speed - 1.8719 * sffm - 30.442 * vars.overstorey_cover / 100.0)));
  }
  return undefined;
}

export function calculatePGOCR(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const sffm = calculateSFFM(wd, vars);
  if (typeof sffm !== 'undefined' &&
      typeof wind_speed !== 'undefined') {
    return 1 / (1 + Math.exp(-(-11.138 + 1.4054 * wind_speed - 3.4217 * sffm)));
  }
  return undefined;
}

export function calculateSROS(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const sffm = calculateSFFM(wd, vars);
  if (typeof sffm !== 'undefined' &&
      typeof wind_speed !== 'undefined') {
    return minZero((3.337 * wind_speed * Math.exp(-0.1284 * sffm) * Math.pow(vars.overstorey_height, -0.7073)) * 60);
  }
  return undefined;
}

export function calculateCROS(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const sffm = calculateSFFM(wd, vars);
  if (typeof sffm !== 'undefined' &&
      typeof wind_speed !== 'undefined') {
    return minZero((9.5751 *
                   wind_speed *
                   Math.exp(-0.1795 * sffm) *
                   Math.pow(vars.overstorey_cover / 100.0, 0.3589)) * 60);
  }
  return undefined;
}

export function calculateEROS(wd, vars) {
  const pgo_cr = calculatePGOCR(wd, vars);
  const cros = calculateCROS(wd, vars);
  const sros = calculateSROS(wd, vars);
  if (typeof pgo_cr !== 'undefined' &&
      typeof cros !== 'undefined' &&
      typeof sros !== 'undefined') {

    if (pgo_cr <= 0.01) {
      return sros;
    }

    if (pgo_cr > 0.99) {
      return cros;
    }

    return (1 - pgo_cr) * sros + pgo_cr * cros;
  }
  return undefined;
}

export function calculateFI(wd, vars) {
  const pgo_cr = calculatePGOCR(wd, vars);
  const eros = calculateEROS(wd, vars);
  if (typeof pgo_cr !== 'undefined' &&
      typeof eros !== 'undefined') {
    return 18600 * vars.fine_fuel_load / 10 * eros / 3600;
  }
  return undefined;
}

export function calculateFH(wd, vars) {
  const fi = calculateFI(wd, vars);
  if (typeof fi !== 'undefined') {
    return 0.01589 * Math.pow(fi, 0.633);
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/mallee_heath/calculations.js